import React, { useEffect, useState } from "react"
import { GetusercartHook } from "../Componentslogic/cartLogic/GetusercartHook"
import { Link } from "react-router-dom"
import "../../Styles/Cartstyle.css"
import backArrow from "../images/back.svg"
import del from "../images/del.svg"
import { motion as m } from "framer-motion"
import { useDispatch, useSelector } from "react-redux"
import { Form } from "react-bootstrap"
import Select from "react-select"
import {
  CALCULATE_TOTAL,
  selectCartAmountDiscounted,
  selectCartitems,
  selectCartTotalAmount,
} from "../../redux/actions/CartSlice"
import Pluslogo from "../images/PLUS.svg"
import Minuslogo from "../images/Minus.svg"
import Modal from "react-modal"
import { db, rtdb } from "../../Firebase/config"
import { ref, set, update, push } from "firebase/database"
import axios from "axios"
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  Timestamp,
  setDoc,
  doc,
} from "firebase/firestore"
import { useNavigate } from "react-router-dom"
import { v4 as uuidv4 } from "uuid"
import Notify from "../Componentslogic/Usenotifications"
Modal.setAppElement("#root")
function Ordereview() {
  const user = JSON.parse(localStorage.getItem("user"))
  const [isSaving, setIsSaving] = useState(false)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [area, setArea] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [waiterRequested, setWaiterRequested] = useState(
    localStorage.getItem("waiterRequested") === "true"
  )
  const cartData = useSelector(selectCartitems)
  const cartTotal = useSelector(selectCartTotalAmount)
  const cartTotaldis = useSelector(selectCartAmountDiscounted)
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [
    handleClearcart,
    pressedClear,
    handleDeleteitem,
    handlepromo,
    onchangepromo,
    promo,
    handleQuantityAdd,
    handleQuantityDecrease,
  ] = GetusercartHook()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    dispatch(CALCULATE_TOTAL())
  }, [dispatch, cartData, promo])

  const handleSaveUser = async (e) => {
    if (isSaving) return

    if (!cartData || cartData.length === 0) {
      Notify(
        "Your cart is empty. Please add items before placing an order.",
        "error"
      )
      return
    }

    setIsSaving(true)
    setIsLoading(true)
    e.preventDefault()

    const orderNumber = uuidv4().replace(/\D/g, "").substring(0, 4)
    const today = new Date()
    const date = today.toDateString()
    const time = today.toLocaleTimeString()
    const egyptianPhoneRegex = /^(010|011|012|015)[0-9]{8}$/

    if (!user) {
      if (!egyptianPhoneRegex.test(phone)) {
        Notify("Please enter a valid Egyptian phone number.", "error")
        setIsSaving(false)
        setIsLoading(false)
        return
      }

      try {
        const q = query(collection(db, "users"), where("phone", "==", phone))
        const querySnapshot = await getDocs(q)

        let userId
        let existingUser

        if (!querySnapshot.empty) {
          existingUser = querySnapshot.docs[0].data()
          userId = querySnapshot.docs[0].id
          localStorage.setItem("user", JSON.stringify(existingUser))
          Notify(`Welcome back ${existingUser.name}!`, "success")
        } else {
          const newUser = {
            name,
            email: email || "",
            area: area || "",
            phone,
            userID: Date.now().toString(),
            createdAt: new Date().toISOString(),
          }
          const docRef = await addDoc(collection(db, "users"), newUser)
          userId = docRef.id
          localStorage.setItem("user", JSON.stringify(newUser))
          Notify(`Thank you ${name}, your account has been created!`, "success")
        }

        // ✅ Call backend to place the order
        const response = await axios.post("/api/place-order", {
          userID: userId,
          userName: name,
          userEmail: email || "",
          phone,
          area,
          cartItems: cartData,
          ordernumber: orderNumber,

          promoDiscount: localStorage.getItem("promodiscount") || 0,
        })

        if (response.data.orderID) {
          localStorage.setItem("orderID", response.data.orderID)
          localStorage.setItem("waiterRequested", "true")
          setWaiterRequested(true)
          Notify("Order placed successfully!", "success")
          navigate("/")
        }
      } catch (error) {
        console.error("Error saving user and order:", error)
        setIsSaving(false)
        isLoading(false)
        Notify("Failed to save order. Please try again.", "error")
      }
    } else {
      try {
        const existingOrderID = localStorage.getItem("orderID")

        if (existingOrderID) {
          // ✅ Call backend to update the existing order
          const response = await axios.post("/api/update-order", {
            orderID: existingOrderID,
            cartItems: cartData,
            totalAmount: cartTotaldis > 0 ? cartTotaldis : cartTotal,
          })

          if (response.data.success) {
            localStorage.setItem("waiterRequested", "true")
            setWaiterRequested(true)
            Notify("Order updated successfully!", "success")
            navigate("/")
          }
        } else {
          // ✅ Call backend to create a new order for an existing user
          const response = await axios.post("/api/place-order", {
            userID: user.userID,
            userName: user.name,
            userEmail: user.email || " ",
            phone: user.phone,
            area: user.area || "",
            cartItems: cartData,
            ordernumber: orderNumber,
            promoDiscount: localStorage.getItem("promodiscount") || 0,
          })

          if (response.data.orderID) {
            localStorage.setItem("orderID", response.data.orderID)
            localStorage.setItem("waiterRequested", "true")
            setWaiterRequested(true)
            Notify("Order created successfully!", "success")
            navigate("/")
          }
        }
      } catch (error) {
        console.error("Error saving or updating order:", error)
        Notify("Failed to save or update order. Please try again.", "error")
      }
    }

    setIsLoading(false)
    setIsSaving(false)
  }

  // Create table options for React Select
  const tableOptions = Array.from({ length: 40 }, (_, index) => ({
    value: index + 1,
    label: `Table ${index + 1}`,
  }))
  return (
    <div className="container-main">
      <div className="head container-cart  ">
        <m.div
          className="Head mb-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <div className="TIT ">Order Review</div>
        </m.div>

        <m.div
          className=" Cart-Space"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {Array.isArray(cartData) && cartData.length > 0 ? (
            cartData.map((item, index) => {
              return (
                <div key={index} className=" Cards-cart d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <h2 className="title-Card">
                      {item.name}{" "}
                      {item.selectedSize ? `(${item.selectedSize})` : ""}
                    </h2>

                    <div className=" mx-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="title-Card">
                          Price:{" "}
                          {(item.Price + (item.combo?.Price || 0)) *
                            item.CartTotalQuantity}{" "}
                          EGP
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-center"
                    style={{ gap: "8px" }}
                  >
                    {item.freeSauce && (
                      <div className="d-flex justify-content-center mt-2 mb-2">
                        <span className="option-square selected p-2">
                          <b>Sauce:</b> {item.freeSauce}
                        </span>
                      </div>
                    )}

                    {item.spiceLevel && (
                      <div className="d-flex justify-content-center mt-2 mb-2">
                        <div>
                          <span className="option-square selected  ">
                            <b> Spice Level: </b> {item.spiceLevel}
                          </span>
                        </div>
                      </div>
                    )}

                    {item.combo && item.combo.name && (
                      <div className="d-flex justify-content-center mt-2 mb-2">
                        <span className="option-square selected p-2">
                          <b>Combo:</b> {item.combo.name} - {item.combo.Price}{" "}
                          EGP
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="options">
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        src={Minuslogo}
                        className="px-2"
                        alt="Plus-icon"
                        onClick={() => handleQuantityDecrease(item)}
                      />

                      <p className="text p-0 m-0">{item.CartTotalQuantity}</p>

                      <img
                        src={Pluslogo}
                        alt="Plus-icon"
                        className="px-2"
                        onClick={() => handleQuantityAdd(item)}
                      />
                    </div>

                    <div className="d-flex justify-content-end ">
                      <img
                        src={del}
                        alt="delete-icon"
                        onClick={() => handleDeleteitem(item)}
                      ></img>
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <div>
              <Link to="/Menu" style={{ textDecoration: "none" }}>
                <div className="d-flex justify-content-center mt-3 ">
                  <p>Back to menu</p>
                </div>
              </Link>
            </div>
          )}
        </m.div>
      </div>
      <m.div
        className="bottom"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        {waiterRequested ? (
          // Friendly message if orderID exists
          <div className="checkout-Login">
            <p className="mb-5 p-0" style={{ color: "white" }}>
              Your order is confirmed! Thank you for dining with us!
            </p>
            <Link to="/">
              <button className="btns-checkout">Back</button>
            </Link>
          </div>
        ) : user ? (
          // Show table selection and button for logged-in users
          <div>
            {isLoading ? (
              <button className="btns-checkout mt-3">Loading</button>
            ) : (
              <button
                className={`btns-checkout mt-3 ${
                  cartData.length === 0 ? "disabled-btn" : ""
                }`}
                onClick={(e) => handleSaveUser(e)}
                disabled={cartData.length === 0 || isLoading}
              >
                {isLoading ? "Loading..." : "Place Order"}
              </button>
            )}
          </div>
        ) : (
          // Show modal trigger for new users
          <button
            className={`btns-checkout mt-3 ${
              cartData.length === 0 ? "disabled-btn" : ""
            }`}
            onClick={(e) => setShowAddressModal(true)}
            disabled={cartData.length === 0 || isLoading}
          >
            {isLoading ? "Loading..." : "Place Order"}
          </button>
        )}
      </m.div>
      {/* Modal for Adding New User */}
      <Modal
        isOpen={showAddressModal}
        onRequestClose={() => setShowAddressModal(false)}
        overlayClassName="modal-overlay"
        className="modal-content"
      >
        <div className="Login-container">
          <h2 className="checkout-Login">
            Hey there! You’ll do this once, then you can Order and review our
            service anytime from the website. Enjoy!
          </h2>

          <Form className="user-form ">
            <Form.Group>
              <Form.Label className="form-name">Name</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
                className="form-input"
                required
              />
            </Form.Group>

            {/* 🔹 Phone Number Field (Premium Styling) */}
            <Form.Group>
              <Form.Label className="form-name">Phone Number</Form.Label>
              <div className="phone-input-container">
                <Form.Control
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter your phone number"
                  className="form-input"
                  maxLength={11}
                  required
                />
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Label className="form-name">
                Email <span className="fw-light">(optional) </span>
              </Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="form-input"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label className="form-name">
                Area <span className="fw-light">(optional) </span>
              </Form.Label>
              <Form.Control
                type="text"
                value={area}
                onChange={(e) => setArea(e.target.value)}
                placeholder="Where are you from? "
                className="form-input"
              />
            </Form.Group>

            <button
              onClick={(e) => handleSaveUser(e)}
              className="buttonsubmit"
              disabled={isSaving} // 🔥 Disable button while processing
            >
              {isSaving ? "Processing..." : "Save and Order"}
            </button>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default Ordereview
